import { PromotionsApi } from '../clients';

export const downloadPayoutReport = async ({ promotionId, batchId, outcome }) =>
  PromotionsApi.downloadPayoutReport(promotionId, batchId, outcome);
